import React, { useState } from "react";

import DashboardLayout from "../../layout/dashboardLayout/DashboardLayout";
import InsuranceDetailsPatientBase from "./InsuranceDetailsPatientBase";
import InsuranceMainPage from "./InsuranceMainPage";

function Insurance() {
  const [selectedInsurance, setSelectedInsurance] = useState(null);
  const [predeterminationOrPostPayment, setPredeterminationOrPostPayment] = useState("predetermination"); // predetermination and post_payment

  return (
    <React.Fragment>
      <DashboardLayout>
        {selectedInsurance === null ? (
          <InsuranceMainPage
            setPredeterminationOrPostPayment={setPredeterminationOrPostPayment}
            predeterminationOrPostPayment={predeterminationOrPostPayment}
            setSelectedInsurance={setSelectedInsurance}
          />
        ) : (
          <InsuranceDetailsPatientBase
            predeterminationOrPostPayment={predeterminationOrPostPayment}
            setSelectedInsurance={setSelectedInsurance}
            selectedInsurance={selectedInsurance}
          />
        )}
      </DashboardLayout>
    </React.Fragment>
  );
}

export default Insurance;
